// import React, { useState, useEffect } from 'react';
// import { Link } from 'lucide-react';
// import {
//   fetchAvailableBuilds,
//   generateSingleLink,
// } from './api';

// import SingleLinkForm from './SingleLinkForm';
// import GeneratedLinkCard from './GeneratedLinkCard';

// const PresignLinkGenerator = () => {
//   const [loading, setLoading] = useState(false);
//   const [availableBuilds, setAvailableBuilds] = useState({});
//   const [generatedLink, setGeneratedLink] = useState(null);
//   const [copied, setCopied] = useState(null);
//   const [message, setMessage] = useState(null); 
  

//   const [formData, setFormData] = useState({
//     build_id: '',
//     expiration_hours: 24,
//     user_email: '',
//     purpose: '',
//   });

//   useEffect(() => {
//     const loadBuilds = async () => {
//       const data = await fetchAvailableBuilds();
//       if (data.success) {
//         setAvailableBuilds(data.builds);
//         const firstBuildId = Object.keys(data.builds)[0];
//         setFormData((p) => ({ ...p, build_id: firstBuildId }));
//       }
//     };
//     loadBuilds();
//   }, []);

//   const handleSingleLink = async () => {
//   setLoading(true);
//   setMessage(null); // clear previous message

//   const data = await generateSingleLink(formData);

//   if (data.success) {
//     setGeneratedLink(data);
//     setMessage({
//       type: "success",
//       text: "Link generated successfully!",
//     });
//   } else {
//     setMessage({
//       type: "error",
//       text: data.error || "Failed to generate link.",
//     });
//   }

//   setLoading(false);
// };


//   const copyToClipboard = async (text, index = null) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       setCopied(index !== null ? `bulk-${index}` : 'single');
//       setTimeout(() => setCopied(null), 2000);
//     } catch {
//       // fallback
//     }
//   };

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
//       <h1 className="text-3xl font-bold text-gray-800 mb-8 flex items-center gap-3">
//         <Link className="text-blue-600" />
//         Presign Link Generator
//       </h1>

//       <SingleLinkForm
//         formData={formData}
//         setFormData={setFormData}
//         availableBuilds={availableBuilds}
//         loading={loading}
//         onGenerate={handleSingleLink}
//       />

//       {generatedLink && (
//         <GeneratedLinkCard
//           generatedLink={generatedLink}
//           copied={copied}
//           copyToClipboard={copyToClipboard}
//         />
//       )}

//     </div>
//   );
// };

// export default PresignLinkGenerator;


import React, { useState, useEffect, useContext } from "react";
import { Link } from "lucide-react";
import { fetchTherapistBuilds, generateSingleLink } from "./api"; // ✅ updated import
import SingleLinkForm from "./SingleLinkForm";
import GeneratedLinkCard from "./GeneratedLinkCard";
import Navbar from "../../../components/Navbar";
import { AuthContext } from "../../../context/AuthContext";
import axios from 'axios';
import Env from '../../../runtimeEnv';

const TherapistPresignLinkGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [availableBuilds, setAvailableBuilds] = useState({});
  const [generatedLink, setGeneratedLink] = useState(null);
  const [copied, setCopied] = useState(null);
  const [message, setMessage] = useState(null);
  const { userType, therapistEmail } = useContext(AuthContext);


  const [formData, setFormData] = useState({
    build_id: "",
    expiration_hours: 24,
    user_email: "",
    purpose: "",
  });

  // useEffect(() => {
  //   const loadTherapistBuilds = async () => {
  //     const data = await fetchTherapistBuilds(); // ✅ fetch therapists + builds
  //     if (data.success) {
  //       // Convert API array → object for dropdown
  //       const therapistMap = {};
  //       data.therapists.forEach((t) => {
  //         therapistMap[t.therapist_id] = {
  //           name: t.name,
  //           description: t.description,
  //           url: t.url,
  //         };
  //       });

  //       setAvailableBuilds(therapistMap);

  //       // Set first therapist as default
  //       const firstTherapistId = Object.keys(therapistMap)[0];
  //       setFormData((prev) => ({ ...prev, build_id: firstTherapistId }));
  //     }
  //   };

  //   loadTherapistBuilds();
  // }, []);

  useEffect(() => {
  const loadTherapistBuilds = async () => {
    const data = await fetchTherapistBuilds();

    if (!data.success) return;

    const therapistMap = {};
    data.therapists.forEach((t) => {
      therapistMap[t.therapist_id] = {
        name: t.name,
        description: t.description,
        url: t.url,
      };
    });

    setAvailableBuilds(therapistMap);

    // -------------------------
    // AUTO-SELECT LOGGED-IN THERAPIST
    // -------------------------

    const therapistEmailMap = {
  "jeanette@plutonic.co": "therapist1",
  "cmorgan@plutonic.co": "therapist2",
  "mlake@plutonic.co": "therapist3",
  "sbranom@plutonic.co": "therapist4",
  "apatel@plutonic.co": "therapist5",
  "bbrownfield@plutonic.co": "therapist6",
  "arozeboom@plutonic.co": "therapist7",
  "jshu@plutonic.co": "therapist8",
  "janay1106@gmail.com": "therapist9",
  "kcortelfraser@plutonic.co": "therapist10",
  "yusheawilliams@gmail.com": "therapist11",
  "gracejunghyun@gmail.com": "therapist12",
  "sarahburgess202@gmail.com": "therapist13",
  "drjacobs@wellbraintherapy.com": "therapist14",
  "shainapage1@gmail.com": "therapist15",
  "alyciashaheed@gmail.com": "therapist16",
  "amberreakes@gmail.com": "therapist17",
  "kathrynw11@yahoo.com": "therapist18",
  "talisa.burke@gmail.com": "therapist19",
  "larry@physicaltherapist.com": "therapist21",
  "earguetaflores@gmail.com": "therapist23",
  "rccarter25@gmail.com": "therapist24",
  "mjwebster61@outlook.com": "therapist25",
  "andrewpaulphipps@gmail.com": "therapist26",
};

    const email = therapistEmail?.toLowerCase();
let matchedId = therapistEmailMap[email];
if (!matchedId) {
  matchedId = ""; // leave dropdown blank
}




    
    setFormData((prev) => ({
      ...prev,
      build_id: matchedId,
    }));
  };

  loadTherapistBuilds();
}, [therapistEmail]);


  const handleSingleLink = async () => {
    setLoading(true);
    setMessage(null);

    const data = await generateSingleLink(formData);

    if (data.success) {
      setGeneratedLink(data);
      setMessage({
        type: "success",
        text: "Link generated successfully!",
      });
    } else {
      setMessage({
        type: "error",
        text: data.error || "Failed to generate link.",
      });
    }

    setLoading(false);
  };

  const copyToClipboard = async (text, index = null) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(index !== null ? `bulk-${index}` : "single");
      setTimeout(() => setCopied(null), 2000);
    } catch {
      // Fallback for older browsers
    }
  };

  return (
    
        <div>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="max-w-4xl w-full bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-8 flex items-center gap-3">
            Instant Session Link Generator
          </h1>

          <SingleLinkForm
            formData={formData}
            setFormData={setFormData}
            availableBuilds={availableBuilds}
            loading={loading}
            onGenerate={handleSingleLink}
          />

          {generatedLink && (
            <GeneratedLinkCard
              generatedLink={generatedLink}
              copied={copied}
              copyToClipboard={copyToClipboard}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TherapistPresignLinkGenerator;
